import { render, staticRenderFns } from "./publicTitle.vue?vue&type=template&id=1163ba59&scoped=true&"
import script from "./publicTitle.vue?vue&type=script&lang=js&"
export * from "./publicTitle.vue?vue&type=script&lang=js&"
import style0 from "./publicTitle.vue?vue&type=style&index=0&id=1163ba59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1163ba59",
  null
  
)

export default component.exports